import type { GiphyPage } from './models';

export const GIPHY_PAGE_SIZE = 15;

export async function fetchGiphy(params: {
  q?: string;
  offset?: number;
  signal?: AbortSignal;
}): Promise<GiphyPage> {
  const sp = new URLSearchParams();
  if (params.q) sp.set('q', params.q);
  sp.set('limit', String(GIPHY_PAGE_SIZE));
  sp.set('offset', String(params.offset ?? 0));

  const res = await fetch(`/api/giphy?${sp.toString()}`, { signal: params.signal });
  if (!res.ok) throw new Error(`giphy proxy ${res.status}`);
  return (await res.json()) as GiphyPage;
}
